import React, { useCallback, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";

import { auth } from "_firebase";
import { useQuery } from "utils/hooks";

import { actions as userActions } from "store/users";
import { selectUserUid } from "store/users/selectors";

import Loading from "components/Loading";

const { confirmUserEmail } = userActions;

const ActionRedirect = ({ uid, confirmUserEmail }) => {
    const didRun = useRef(false);

    const history = useHistory();
    const searchParams = useQuery();

    const mode = searchParams.get("mode");
    const oobCode = searchParams.get("oobCode");
    const apiKey = searchParams.get("apiKey");

    const redirect = useCallback(async () => {
        let redirectUrl = uid ? `/dashboard` : "/login";

        if (mode === "resetPassword" && oobCode && apiKey) {
            redirectUrl = `/password-reset/new-password?oobCode=${oobCode}&apiKey=${apiKey}`;
        }

        if (mode === "verifyEmail" && oobCode && apiKey) {
            try {
                if (auth.currentUser?.emailVerified) {
                    await confirmUserEmail(uid);

                    redirectUrl = "/dashboard";
                } else {
                    await auth.applyActionCode(oobCode);
                    await auth.currentUser.reload();

                    await confirmUserEmail(uid);

                    redirectUrl = "/dashboard";
                }
            } catch (error) {
                console.error("Error verifying email:", error);
            }
        }

        history.replace(redirectUrl);
    }, []);

    useEffect(() => {
        if (didRun.current) return; // prevent second run in dev

        didRun.current = true;

        (async () => {
            await redirect();
        })();
    }, []);

    return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "85vh" }}>
            <Loading />
        </div>
    );
};

const mapStateToProps = createStructuredSelector({
    uid: selectUserUid,
});

const mapDispatchToProps = (dispatch) => ({
    confirmUserEmail: (uid) => dispatch(confirmUserEmail(uid)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ActionRedirect);
